import CaseLocationComponent from '../../Components/Masters/CaseLocation/CaseLocationComponent'

function CaseLocationPage() {
    return (
        <CaseLocationComponent/>
    )
}

export default CaseLocationPage